var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.638,
    height: 14,
    viewBox: "0 0 17.638 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_18183",
    "data-name": "Path 18183",
    d: "M10,3a8.867,8.867,0,0,1,8.819,7A8.866,8.866,0,0,1,10,17a8.867,8.867,0,0,1-8.819-7A8.866,8.866,0,0,1,10,3Zm0,12.444A7.275,7.275,0,0,0,17.154,10,7.276,7.276,0,0,0,10,4.564,7.276,7.276,0,0,0,2.845,10,7.275,7.275,0,0,0,10,15.444ZM10,13.5A3.587,3.587,0,0,1,6.332,10,3.587,3.587,0,0,1,10,6.5,3.587,3.587,0,0,1,13.668,10,3.587,3.587,0,0,1,10,13.5Zm0-1.556A1.947,1.947,0,1,0,7.962,10,1.993,1.993,0,0,0,10,11.944Z",
    transform: "translate(-1.181 -3)",
    fill: "#acb0be"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.a71f8688495596c48c430777e529fdac.svg";
export { ForwardRef as ReactComponent };